module.exports = __webpack_public_path__ + "img/dayl.fb62f7e2.jpg";